exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.action[data-v-555a3688]{margin-right:5px!important}", ""]);

// exports
